/**
 * Checkout Reducer Helper Function
 */

import { environment } from '../../relay';
import { AddPromoCodeMutation, DeletePromoCodeMutation, PlaceOrderMutation } from '../../relay/checkout';

import { commitMutation } from 'react-relay';

export const isActiveStep = (stepId: string) =>
  ({ checkout }: IStoreState) => checkout.activeStep === stepId;
export const isReadyToPlaceOrder = ({ checkout }: IStoreState) =>
  !!checkout.steps.length && checkout.completedSteps.length === checkout.steps.length;

export const addPromoCode = ({ code, country_code, subdivision_code }: IAddPromoCodeActionPayload) => {
  const input: GQL.IAddPromoCodeInput = {
    code,
  };
  return new Promise<any>((resolve, reject) => {
    commitMutation(environment, {
      mutation: AddPromoCodeMutation,
      variables: {
        input,
        country_code,
        subdivision_code,
      },
      onCompleted: (response, errors) => resolve(errors),
      onError: reject,
    });
  });
};

export const deletePromoCode = ({ country_code, subdivision_code }: ICheckoutQueryVariables) => {
  return new Promise<any>((resolve, reject) => {
    commitMutation(environment, {
      mutation: DeletePromoCodeMutation,
      variables: {
        input: {},
        country_code,
        subdivision_code,
      },
      onCompleted: (response, errors) => resolve(errors),
      onError: reject,
    });
  });
};

export const placeOrder = ({ input, viewerId }: IPlaceOrderActionPayload) => {
  return new Promise<any>((resolve, reject) => {
    commitMutation(environment, {
      mutation: PlaceOrderMutation,
      variables: { input },
      updater: (storeProxy) => {
        const viewerRecord = storeProxy.get(viewerId)!;
        viewerRecord.setValue(null, 'cart');
      },
      onCompleted: (response, errors) => {
        if (!errors) {
          // Induce a delay so the user feels something is processing in the background
          setTimeout(() => resolve(response.placeOrder), 3000);
        } else {
          reject(errors);
        }
      },
      onError: reject,
    });
  });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/helpers/checkout.ts